import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";

const routes: Routes = [
  {
    path: "",
    loadChildren: () =>
      import("./pages/tabs/tabs.module").then((m) => m.TabsPageModule),
  },
  {
    path: "clientProfile/:clientId",
    loadChildren: () =>
      import("./pages/client-profile/client-profile.module").then(
        (m) => m.ClientProfilePageModule
      ),
  },
  {
    path: "viewAppointment",
    loadChildren: () =>
      import("./pages/view-appointment/view-appointment.module").then(
        (m) => m.ViewAppointmentPageModule
      ),
  },
  {
    path: "appointments",
    loadChildren: () =>
      import("./pages/appointments/appointments.module").then(
        (m) => m.AppointmentsPageModule
      ),
  },
  {
    path: "signin",
    loadChildren: () =>
      import("./pages/signin/signin.module").then((m) => m.SigninPageModule),
  },
  {
    path: "gallery",
    loadChildren: () =>
      import("./pages/gallary/gallary.module").then((m) => m.GallaryPageModule),
  },
  {
    path: "services",
    loadChildren: () =>
      import("./pages/services/services.module").then(
        (m) => m.ServicesPageModule
      ),
  },
  {
    path: "service/:action",
    loadChildren: () =>
      import("./pages/add-service/add-service.module").then(
        (m) => m.AddServicePageModule
      ),
  },
  {
    path: "reviews",
    loadChildren: () =>
      import("./pages/reviews/reviews.module").then((m) => m.ReviewsPageModule),
  },
  {
    path: "staff",
    loadChildren: () =>
      import("./pages/staff/staff.module").then((m) => m.StaffPageModule),
  },
  {
    path: "addGallary/:action",
    loadChildren: () =>
      import("./pages/add-gallary/add-gallary.module").then(
        (m) => m.AddGallaryPageModule
      ),
  },
  {
    path: "editProfile",
    loadChildren: () =>
      import("./pages/edit-profile/edit-profile.module").then(
        (m) => m.EditProfilePageModule
      ),
  },
  {
    path: "editKyc",
    loadChildren: () =>
      import("./pages/edit-kyc/edit-kyc.module").then(
        (m) => m.EditKycPageModule
      ),
  },
  {
    path: "updateMobile",
    loadChildren: () =>
      import("./pages/update-mobile/update-mobile/update-mobile.module").then(
        (m) => m.UpdateMobilePageModule
      ),
  },
  {
    path: "updateEmail",
    loadChildren: () =>
      import("./pages/update-email/update-email/update-email.module").then(
        (m) => m.UpdateEmailPageModule
      ),
  },
  {
    path: "setting",
    loadChildren: () =>
      import("./pages/setting/setting.module").then((m) => m.SettingPageModule),
  },
  {
    path: "companySetting",
    loadChildren: () =>
      import("./pages/company-setting/company-setting.module").then(
        (m) => m.CompanySettingPageModule
      ),
  },
  {
    path: "dashboard",
    loadChildren: () =>
      import("./pages/dashboard/dashboard.module").then(
        (m) => m.DashboardPageModule
      ),
  },
  {
    path: "reports",
    loadChildren: () =>
      import("./pages/reports/reports.module").then((m) => m.ReportsPageModule),
  },
  {
    path: "forgotPassword",
    loadChildren: () =>
      import("./pages/forgot-password/forgot-password.module").then(
        (m) => m.ForgotPasswordPageModule
      ),
  },
  {
    path: "addClients",
    loadChildren: () =>
      import("./pages/add-clients/add-clients.module").then(
        (m) => m.AddClientsPageModule
      ),
  },
  {
    path: "selectServices",
    loadChildren: () =>
      import("./pages/select-services/select-services.module").then(
        (m) => m.SelectServicesPageModule
      ),
  },
  {
    path: "register",
    loadChildren: () =>
      import("./pages/register/register.module").then(
        (m) => m.RegisterPageModule
      ),
  },
  {
    path: "salon-add",
    loadChildren: () =>
      import("./pages/salon-add/salon-add.module").then(
        (m) => m.SalonAddPageModule
      ),
  },
  {
    path: "employee-detail",
    loadChildren: () =>
      import("./pages/employee-detail/employee-detail.module").then(
        (m) => m.EmployeeDetailPageModule
      ),
  },
  {
    path: "add-employees",
    loadChildren: () =>
      import("./pages/add-employees/add-employees.module").then(
        (m) => m.AddEmployeesPageModule
      ),
  },
  {
    path: "delete",
    loadChildren: () =>
      import("./modals/delete/delete.module").then((m) => m.DeletePageModule),
  },
  {
    path: "add-salon",
    loadChildren: () =>
      import("./pages/add-salon/add-salon.module").then(
        (m) => m.AddSalonPageModule
      ),
  },
  {
    path: "select-address",
    loadChildren: () =>
      import("./pages/select-address/select-address.module").then(
        (m) => m.SelectAddressPageModule
      ),
  },
  {
    path: "add-adress",
    loadChildren: () =>
      import("./pages/add-adress/add-adress.module").then(
        (m) => m.AddAdressPageModule
      ),
  },
  {
    path: "contact-us",
    loadChildren: () =>
      import("./pages/contact-us/contact-us.module").then(
        (m) => m.ContactUsPageModule
      ),
  },
  {
    path: "generate-offer",
    loadChildren: () =>
      import("./pages/generate-offer/generate-offer.module").then(
        (m) => m.GenerateOfferPageModule
      ),
  },
  {
    path: 'email-raise-ticket',
    loadChildren: () => import('./pages/email-raise-ticket/email-raise-ticket.module').then(m => m.EmailRaiseTicketPageModule)
  },
  {
    path:"help-support",
    loadChildren: () => import('./pages/help-support/help-support.module').then(m => m.HelpSupportPageModule)
  },
  {
    path:"privacy-policy",
    loadChildren: () => import('./pages/privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyPageModule)
  },
   {
    path:"terms-conditions",
    loadChildren: () => import('./pages/terms-conditions/terms-conditions.module').then(m => m.TermsConditionsPageModule)
  },
  {
    path:"refund-policy",
    loadChildren: () => import('./pages/refund-policy/refund-policy.module').then(m => m.RefundPolicyPageModule)
  },
  // {
  //   path:"cancellation-policy",
  //   loadChildren: () => import('./pages/cancellation-policy/cancellation-policy.module').then(m => m.CancellationPolicyPageModule)
  // },
    {
    path:"apply-leave",
    loadChildren: () => import('./pages/apply-leave/apply-leave.module').then(m => m.ApplyLeavePageModule)
  },
  {
    path: "staff-on-leave",
    loadChildren: () =>
      import("./pages/staff-on-leave/staff-on-leave.module").then((m) => m.StaffOnLeavePageModule),
  },
  {
    path:"requist-category",
    loadChildren: () => import('./pages/requist-category/requist-category.module').then(m => m.RequistCategoryPageModule)
  },
  {
    path:"about-us",
    loadChildren: () => import('./pages/about-us/about-us.module').then(m => m.AddAdressPageModule)
  },  
  {
    path:"community-guidelines",
    loadChildren: () => import('./pages/community-guidelines/community-guidelines.module').then(m => m.CommunityGuidelinesPageModule)
  },
  {
    path:"data-protection",
    loadChildren: () => import('./pages/data-protection/data-protection.module').then(m => m.DataProtectionPageModule)
  },
  {
    path:"cookie-policy",
    loadChildren: () => import('./pages/cookie-policy/cookie-policy.module').then(m => m.CookiePolicyPageModule)
  },
  {
    path:"feedback-suggestions",
    loadChildren: () => import('./pages/feedback-suggestions/feedback-suggestions.module').then(m => m.FeedbackSuggestionsPageModule)
  },
  {
    path:"support-tickets",
    loadChildren: () => import('./pages/support-tickets/support-tickets.module').then(m => m.SupportTicketsPageModule)
  },
  {
    path:"app-version",
    loadChildren: () => import('./pages/app-version/app-version.module').then(m => m.AppVersionPageModule)
  },
  {
    path:"user-agreement",
    loadChildren: () => import('./pages/user-agreement/user-agreement.module').then(m => m.UserAgreementPageModule)
  },
  {
    path:"data-usage",
    loadChildren: () => import('./pages/data-usage/data-usage.module').then(m => m.DataProtectionPageModule)
  },
  {
    path:"location-settings",
    loadChildren: () => import('./pages/location-settings/location-settings.module').then(m => m.LocationSettingsPageModule)
  },
  {
    path:"request-category",
    loadChildren: () => import('./pages/requist-category/requist-category.module').then(m => m.RequistCategoryPageModule)
  },
  {
    path:"submit-request",
    loadChildren: () => import('./pages/submit-request/submit-request.module').then(m => m.SubmitRequestPageModule)
  },
  {
    path:"security-settings",
    loadChildren: () => import('./pages/security-settings/security-settings.module').then(m => m.SecuritySettingsPageModule)
  },
  {
    path:"forgot-password",
    loadChildren: () => import('./pages/forgot-password/forgot-password.module').then(m => m.ForgotPasswordPageModule)
  }
  
  
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      relativeLinkResolution: "legacy",
      useHash: true
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
